<template>
    <!-- search input -->
    <div class="search-container"></div>
    <v-spacer></v-spacer>
    <div class="user-container mr-3">
        <!-- user logo -->
        <v-img class="user-logo" :src="userPicture"></v-img>
        <!-- user details -->
        <div class="user-details-container">
            <div data-cy="userName" class="user-name body-medium white-text">
                {{ userName }}
            </div>
            <div
                data-cy="partnerName"
                class="user-role body-small secondary-text"
            >
                {{ partnerName }}
            </div>
        </div>
        <!-- settings button -->
        <div v-if="hasPartnerPermissions" class="settings-container">
            <v-menu>
                <template #activator="{ props }">
                    <icon-button
                        data-cy="userMenuButton"
                        btn-style="default-btn medium-icon-btn transparent-btn"
                        :icon-src="getImageUrl('icons/20x20/ic20-more-hor.svg')"
                        v-bind="props"
                    />
                </template>
                <v-list class="user-menu" data-cy="userMenu">
                    <v-list-item
                        data-cy="menuSettingsButton"
                        class="user-menu-item"
                        @click="
                            changeRoute('/partner/settings/account-information')
                        "
                    >
                        <template #prepend>
                            <img
                                class="mr-4"
                                :src="
                                    getImageUrl('icons/20x20/ic20-settings.svg')
                                "
                            />
                        </template>
                        <v-list-item-title class="mr-2 body-medium white-text"
                            >Settings</v-list-item-title
                        >
                    </v-list-item>
                    <v-list-item
                        data-cy="menuLogoutButton"
                        class="user-menu-item"
                        @click="handleLogout()"
                    >
                        <template #prepend>
                            <img
                                class="mr-4"
                                :src="
                                    getImageUrl('icons/20x20/ic20-log-out.svg')
                                "
                            />
                        </template>
                        <v-list-item-title class="mr-2 body-medium white-text"
                            >Logout</v-list-item-title
                        >
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { signOut } from "aws-amplify/auth";
import { useRouter } from "vue-router";
import { usePiniaStore } from "@/stores/store";
import { usePartnerStore } from "@/stores/partner";
import { useSessionStore } from "@/stores/session";

import iconButton from "@/components/buttons/iconButton.vue";

import { getImageUrl } from "@/methods/iconHelpers";
import { redirectToRoute } from "@/router";
import { AuthRouteNames } from "@/constants/routes";

const router = useRouter();
const piniaStore = usePiniaStore();
const partnerStore = usePartnerStore();
const sessionStore = useSessionStore();

// get user details
const userPicture = computed(() => "");
const userName = computed(() => sessionStore.userEmail);
const partnerName = computed(
    () => partnerStore.partnerProfile.partnerBusinessName,
);
const hasPartnerPermissions = computed(
    () => Object.keys(sessionStore.permissions ?? {}).length > 0,
);

const changeRoute = (path: string) => {
    router.push(path).catch((err) => {
        console.log("Route error: " + err);
    });
};

// logs user out
const handleLogout = async () => {
    await signOut({ global: true });
    piniaStore.clearUserSession();
    redirectToRoute({ name: AuthRouteNames.LOGIN });
};
</script>
